<template>
  <div id="app">
    <meta name="viewport"
          content="width=device-width, initial-scale=1.0,minimum-scale=1.0, maximum-scale=1.0, user-scalable=no">
    <div id="nav"></div>
    <router-view />
    <!-- <transition name="slide-fade">
      <router-view />
    </transition> -->

  </div>
</template>
<script>
export default {
  data() {
    return {
      transitionName: '',
    }
  },
}
window.onload = function () {
  document.addEventListener('touchstart', function (event) {
    if (event.touches.length > 1) {
      event.preventDefault()
    }
  })
  document.addEventListener('gesturestart', function (event) {
    event.preventDefault()
  })
}
</script>

<style lang="less">
body,
html,
#app {
  width: 100%;
  height: 100%;
  background: #f2f2f2;
  font-family: PingFangSC-Regular;
}
a {
  text-decoration: none;
  color: #000;
}

h1,
h2,
h3,
h4,
h5,
h6,
p {
  margin: 0;
  font-weight: normal;
}

// .slide-right-enter-active,
// .slide-right-leave-active,
// .slide-left-enter-active,
// .slide-left-leave-active {
//   will-change: transform;
//   transition: all 500ms;
//   position: absolute;
// }
// .slide-right-enter {
//   opacity: 0;
//   transform: translateX(-100%);
// }

// .slide-right-leave-active {
//   opacity: 0;
//   transform: translateX(100%);
// }

// .slide-left-enter {
//   opacity: 0;
//   transform: translateX(100%);
// }

// .slide-left-leave-active {
//   opacity: 0;
//   transform: translateX(-100%);
// }

.slide-fade {
  position: fixed;
  left: 0;
  right: 0;
  width: 100%;
  background-color: #f2f2f2;
}
.slide-fade-enter,
.slide-fade-leave-to {
  left: 0;
  top: 0;
  right: 0;
  position: absolute;
  transform: translateX(-100%);
  // transform: translateX(-500px) translateY(-500px) rotate(-150deg) scale(0.5);
  opacity: 1;
}

.slide-fade-enter-active {
  background-color: #f2f2f2;
  transition: all 0.6s ease;
}
.slide-fade-leave-active {
  transition: all 0.7s ease;
  background-color: #f2f2f2;
  transform: translateX(100%);
  // transform: translateX(500px) translateY(500px) rotate(150deg) scale(1);
  z-index: 100;
}
</style>
